var _defs, _rect, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 5711.9 2608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient);\n      }\n\n      .st6 {\n        fill: #ccc;\n      }\n\n      .st7 {\n        display: none;\n      }\n\n      .st7, .st8 {\n        fill: #fff;\n      }\n\n      .st9 {\n        fill: #ddd;\n      }\n\n      .st10 {\n        fill: #e30613;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2925.2,
    y1: 2809.3,
    x2: 3249.4,
    y2: 2795.4,
    gradientTransform: "translate(-1534.8 -1091.6) rotate(-11.9) scale(1 1.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#706f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 2537.2,
    y1: 2756,
    x2: 2537.2,
    y2: 2514.6,
    gradientTransform: "translate(-790.4 -1018.1) rotate(-6.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 1810,
    y1: 3241.7,
    x2: 1810,
    y2: 2523.7,
    gradientTransform: "translate(-873.5 -949.6) rotate(-10.6) scale(1.2 1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 2083.8,
    y1: 3251.7,
    x2: 2019.1,
    y2: 3278.7,
    gradientTransform: "translate(-1088.2 -1025.5) rotate(-11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 1997.4,
    y1: 3137.3,
    x2: 1997.4,
    y2: 2763.6,
    gradientTransform: "translate(-1088.2 -1025.5) rotate(-11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 2022,
    y1: 1696.1,
    x2: 2022,
    y2: 896.5,
    gradientTransform: "translate(461.8 -470.8) rotate(15.3)",
    xlinkHref: "#linear-gradient1"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    y: 176.6,
    width: 5675.7,
    height: 2296.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2206.8,1281.9c39.6,198.5,10.4,373.1-65.3,390-75.7,16.9-169.2-130.2-208.9-328.7-39.6-198.5-10.4-373.1,65.3-390,75.7-16.9,169.2,130.2,208.9,328.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1944.2,1219.7c-5.3.3-9.7,4.3-9.7,9-.1,42,3.5,83.5,10.3,124.7,5.6,33.9,13.2,67.1,23.3,99.7,1.4,4.5,6.7,6.9,11.9,5.3,65.2-19.9,108.9-79.1,99.8-139.9-9.1-60.8-67.8-102.2-135.5-98.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2048.5,1695.7c-11.9-8.5-22.9-18.1-33.2-28.3-33.6-33.2-59-71.2-80.5-111.5-19.8-37-35.5-75.6-48.3-115.3-14.6-45.3-25.2-91.6-31.5-138.9-7.4-55.7-9.1-111.8-1.2-168.6,5.1-36.9,14.2-73.2,31.8-108.1,0,0,0-.1,0-.2,1.1-2.2-2.1-3.7-3.8-1.8-86,93.7-212,191.2-362.9,264,.1,6.7.4,13.3.7,20,2.6,58.4,12,115.5,26.6,171.8,13.8,53.4,32.2,105.1,56.5,154.9,167.3-5.6,323.9,22.2,443.2,65.3,2.4.9,4.5-2,2.5-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1592.7,1611.9c-.9,1.7-2.3,3-4.2,3.6l-67,20.4c-16.5,5-33.1,7.3-49.5,7.2l97.3,238.7c13.7,33.5,52.8,47.1,87,30.2h0c34.9-17.3,50.8-59.3,35-92.6l-98.6-207.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1560.8,1475.3c-14.6-55.1-24.2-111.1-27.4-168.2-.4-6.5-.7-13.1-.9-19.6-.1-4.4-4.8-7.4-9.6-6.2l-76.3,19.6c-109.5,28.2-178.7,129.6-154.6,226.6l1.7,6.9c24.1,97,132.5,152.8,242,124.7l76.4-19.6c4.8-1.2,7.5-6.1,5.6-10.1-24.3-49.4-42.7-101-56.7-154.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2291.8,1526.4c-4.2,36.6-11.6,72.3-25.4,106.4-11.1,27.4-25.6,52.5-46.9,72.6-24.5,23.2-53.1,35.5-86.2,34.9-27-.5-51.6-9.8-74.6-24.5-25.3-16.2-46.5-37.3-65.5-61-30-37.4-53.4-79.2-72.9-123.5-33.4-75.7-54.8-155.2-66.7-237.6-5.9-40.6-8.9-81.4-8.7-122.5.1-25.4,1.6-50.8,4.8-76,4.8-37.5,12.8-74.2,27.7-108.9,11.7-27.1,26.8-51.6,48.9-70.6,31-26.8,66.2-36.3,105.6-27.8,32.7,7,59.9,25.1,84.5,48.1,31.4,29.4,56,64.7,77.2,102.7,34.7,62.3,58.8,129.2,76,199,13.2,53.5,21.8,107.7,25.3,162.9,2.4,38.2,2.3,76.3-1.7,114.4-.4,3.9-.9,7.7-1.4,11.5ZM2203.2,1514.2c2.9-23.9,3.9-47.9,3.5-72-.7-50.7-6.7-100.8-17-150.3-13.3-63.5-32.7-124.6-61.3-182.3-16.8-33.9-36.3-65.8-61.8-93.2-12.2-13.1-25.4-24.7-41.5-32.1-19.5-9.1-34.2-5.8-48.4,11-9,10.7-15.3,23.1-20.4,36.3-10.5,27.5-15.9,56.2-19,85.6-2.8,26.4-3.4,52.8-2.6,79.2,1.4,44.7,6.9,88.9,15.8,132.7,13.3,65.2,33.1,128,62.5,187.2,16.6,33.4,35.9,65,61.1,92.1,12.5,13.5,26.1,25.5,42.8,33,19.1,8.6,33.7,5.1,47.5-11.3,8.4-10,14.4-21.6,19.4-33.8,10.5-26.3,16-53.9,19.4-82Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2232.6,1535.8c35.2-58.7,51.3-136.9,39.6-219.1-11.7-82.2-48.9-152.1-98.8-197.3-8.1-7.3-19.3,3.5-13.2,12.7,32.9,49.6,57.9,116.2,68.6,191.5,10.7,75.3,5.4,146.7-12.2,204.2-3.3,10.7,10.5,17.5,16.2,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2162.9,1464.8c21.6-36.1,31.5-84.2,24.3-134.7-7.2-50.5-30-93.5-60.7-121.3-5-4.5-11.9,2.1-8.1,7.8,20.2,30.5,35.6,71.4,42.1,117.7,6.6,46.3,3.3,90.2-7.5,125.5-2,6.6,6.5,10.8,9.9,4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2369.9,1301.2c-15.4-108.2-64.3-200.1-130.1-259.7-10.6-9.6-25.4,4.6-17.4,16.7,43.2,65.3,76.1,152.9,90.2,252,14.1,99.1,7.1,193-16.1,268.8-4.3,14,13.8,23,21.3,10.6,46.3-77.2,67.5-180.2,52.1-288.4Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2268.5,1752.9c-27.1,23-58.6,38.7-95.3,45.2-44.8,7.9-88,1.5-128.9-18.3-15.8-7.7-30.4-17.8-45.6-26.7-2.8-1.7-5.7-3.4-8.9-4.3-46.5-13.3-93.6-23.7-141.5-30-32.5-4.3-65.2-7.3-97.8-10.8-3.1-.3-6.2,0-10,0,5.1,9.9,10.1,19.4,14.9,29.1,8.3,16.8,18.7,32.8,23.4,51.2,13.6,52.4,1.6,98.7-34.8,138.3-26.5,28.9-60.2,44.8-99.3,47.8-60.6,4.7-116.4-27.6-140.3-81.8-22.5-51-45.2-101.9-67.7-152.9-1.7-3.7-3.8-5.3-7.9-6.1-76.5-14.6-140.4-50.2-180.4-118.5-51.7-88.4-48.1-177.2,9.8-261.9,41.8-61.2,101.5-97.7,172.7-116.2,26.6-6.9,53.4-12.9,79.8-20.4,9.8-2.8,18.7-8.6,27.8-13.4,85.4-45.3,164.7-99.4,236.6-164.3,5.4-4.8,8.9-10.1,11.1-17.1,12.9-41.8,31.5-80.6,61.1-113.4,34.4-38,76.3-62.6,127.6-69.2,43.1-5.6,84.2,2.3,123.3,21.1,44.8,21.7,80.8,54.3,112.2,92.3,5.9,7.2,11.7,12.1,21.6,13.4,4.7.7,9.3,1.8,13.6,3.4L3296.3,6.6H0v2596.1h3326l-1057.5-849.8Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M3220.7,1595.6h-147.5l-23.6-59.6h-170.4l-23.6,59.6h-147.5l254.9-518.1h2.8l254.9,518.1ZM2918,1437.7h92.8l-46.4-119.1-46.4,119.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M3609.9,1155.7l-82.4,95.6c-22.9-29.1-56.8-54-104.6-54-81,0-131.6,59.6-131.6,143.4s50.6,144.1,131.6,144.1,81.7-24.9,104.6-54l81.7,95.6c-51.9,57.5-111.5,78.3-186.3,78.3-155.2,0-265.3-113.6-265.3-263.9s110.1-263.2,265.3-263.2,136.5,25.6,187,78.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M4065.7,1202.2h-155.2v393.4h-131.6v-393.4h-155.2v-115.7h441.9v115.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M4500,1409.9c0,116.4-70,194.6-201.6,194.6s-201.6-78.3-201.6-194.6v-323.5h131.6v314.5c0,49.2,23.5,83.8,70,83.8s70-34.6,70-83.8v-314.5h131.6v323.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M4925.3,1130.8l-67.9,108.7c-29.1-23.6-65.8-42.3-119.8-42.3s-55.4,12.5-55.4,36.7,12.5,29.8,81,41.6c137.8,28.4,175.9,81,175.9,158.6s-74.8,170.4-200.9,170.4-153.8-24.2-205.7-70l70.7-109.4c32.6,36,89.4,59.6,139.2,59.6s65.1-13.2,65.1-38.1-14.5-30.5-83.1-42.9c-137.1-29.1-174.5-89.4-174.5-162.8s72.7-163.5,188.4-163.5,144.1,20.1,187,53.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.51bba25675084d73da5653a2ebc329bb.svg";
export { ForwardRef as ReactComponent };